import { gql } from "@apollo/client";

export const GET_FILE_UPLOAD_ADMIN_PAGE = gql`
  query getFileUploadPage {
    getFileUploadFileTypes {
      value
      label
      subType {
        subtypeId
        recordId
        subtype
        createdOn
        createdBy
        updatedOn
        updatedBy
        active
      }
    }
    getFileUploadDetailsAndAssignments {
      recordId
      fileTypeDescription
      emailMessage
      emailSubject
      createdOn
      createdBy
      active
      assignedTo {
        recordId
        umdId
        email
        sendType
      }
    }
    getAllDdwStaff {
      value
      label
    }
  }
`;

export const GET_FU_EMAIL_DETAILS = gql`
  query getFileUploadDetailsAndAssignments {
    getFileUploadDetailsAndAssignments {
      recordId
      fileTypeDescription
      emailMessage
      emailSubject
      createdOn
      createdBy
      active
      assignedTo {
        recordId
        umdId
        email
        sendType
      }
    }
  }
`;

export const GET_DOC_TYPES = gql`
  query getFileUploadFileTypes {
    getFileUploadFileTypes {
      value
      label
    }
  }
`;

export const ADD_DOC_TYPE = gql`
  mutation AddDocType($label: String!, $createdBy: String!, $subType: [AddFileSubType]!) {
    addFileUploadDocType(AddDocType: { label: $label, createdBy: $createdBy, subType: $subType }) {
      label
      value
      subType {
        subtypeId
        recordId
        subtype
        createdOn
        createdBy
        updatedOn
        updatedBy
        active
      }
    }
  }
`;

export const UPDATE_DOC_TYPE = gql`
  mutation UpdateDocType(
    $recordId: Int!
    $label: String!
    $updatedBy: String!
    $subType: [UpdateFileSubType]
    $active: Boolean!
  ) {
    updateFileUploadDocType(
      UpdateFileDocType: {
        recordId: $recordId
        label: $label
        updatedBy: $updatedBy
        subType: $subType
        active: $active
      }
    ) {
      label
      value
      subType {
        subtypeId
        recordId
        subtype
        createdOn
        createdBy
        updatedOn
        updatedBy
        active
      }
    }
  }
`;

export const DELETE_DOC_TYPE = gql`
  mutation UpdateDocType(
    $recordId: Int!
    $label: String!
    $updatedBy: String!
    $subType: [UpdateFileSubType]
    $active: Boolean!
  ) {
    deleteFileUploadDocType(
      UpdateFileDocType: {
        recordId: $recordId
        label: $label
        updatedBy: $updatedBy
        subType: $subType
        active: $active
      }
    ) {
      label
      value
    }
  }
`;

export const UPDATE_FU_EMAIL_DETAILS = gql`
  mutation UpdateFileUploadEmail(
    $recordId: Int!
    $emailSubject: String
    $emailMessage: String
    $updatedBy: String!
    $assignedTo: [UpdateFileUploadAssignment]
    $active: Boolean!
  ) {
    updateFileUploadDetailsAndAssignments(
      UpdateFileUploadEmail: {
        recordId: $recordId
        emailSubject: $emailSubject
        emailMessage: $emailMessage
        updatedBy: $updatedBy
        assignedTo: $assignedTo
        active: $active
      }
    ) {
      recordId
      emailSubject
      emailMessage
      createdBy
      createdOn
      updatedBy
      updatedOn
      active
      assignedTo {
        recordId
        umdId
        email
        sendType
      }
    }
  }
`;
